



































































import { Component, Prop, Vue, Watch, Ref } from "vue-property-decorator";
import { ValidationRules } from "../../plugins/validate";
import { stringIsNullOrEmpty } from "_P/strings";
import { mask } from "vue-the-mask";

@Component({ inheritAttrs: false, directives: { mask } })
export default class ppdwDateField extends Vue {
    @Prop({ default: () => [] }) rules: Function[];
    @Prop() value: Date;
    @Prop({ default: "" }) label: string;
    @Prop({ default: "__.__.____" }) placeholder: string;
    @Prop() max: string;
    @Prop() min: string;
    @Prop({ default: false }) readonly: boolean;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: false }) hideDetails: boolean;
    @Prop({ default: 48 }) nudgeBottom: number;
    @Prop({ default: 0 }) nudgeTop: number;
    @Prop(Boolean) top: boolean;
    @Ref("field") field: {
        $el: HTMLElement;
        initialValue: string;
        lazyValue: string;
        isFocused: boolean;
    };

    menu: boolean = false;
    svg = require("@/assets/img/ppdw-calendar.svg");

    dateRule: Function = v =>
        stringIsNullOrEmpty(v) ||
        v.match(/[0-3][0-9][.][0-1][0-9][.](19|20)([0-9]{2})/) !== null ||
        "Неверная дата";

    get allRules() {
        return [
            ...this.rules,
            this.dateRule,
            this.minDateRule,
            this.maxDateRule
        ];
    }
    get fieldDate(): string {
        return !!this.value && !!this.value.toLocaleDateString
            ? this.value
                .toLocaleDateString("ru-RU")
                .replace(/[^\x00-\x7F]/g, "")
                .toString()
            : "";
    }
    set fieldDate(v: string) {
        if (this.dateRule(v) !== true) {
            return;
        }
        let dp: string[] = v.split(".");
        this.$emit("input", new Date(`${dp[2]}-${dp[1]}-${dp[0]}`));
        //this.$nextTick(() => this.checkSuccess(this.fieldDate, this.rules));
    }
    key: number = 1;
    @Watch("fieldDate")
    onFieldDateChanged(val) {
        this.checkSuccess(this.fieldDate, this.rules);
        this.key++;
    }

    get pickerDate(): string {
        if (this.value?.toString() == "Invalid Date" ?? true) return "";
        return this.value?.format?.("yyyy-MM-dd") ?? "";
    }
    set pickerDate(v: string) {
        this.$emit("input", new Date(v));
        //this.$nextTick(() => this.checkSuccess(this.fieldDate, this.rules));
    }

    minDateRule(v: string) {
        if (!this.min) return true;

        let dp: string[] = v.split(".");
        let date = new Date(`${dp[2]}-${dp[1]}-${dp[0]}`);

        const isRealDate = !!date?.getTime() || date?.getTime() === 0;
        const isUnderConstraints =
            date?.getTime() >= new Date(this.min)?.setHours(0);
        const isRequired = this.rules.includes(ValidationRules.requiredRule);

        if (!isRealDate && isRequired) return "Неверная дата";
        if (isRealDate && !isUnderConstraints) return "Слишком рано";
        else return true;
    }

    maxDateRule(v: string) {
        if (!this.max) return true;

        let dp: string[] = v.split(".");
        let date = new Date(`${dp[2]}-${dp[1]}-${dp[0]}`);

        const isRealDate = !!date?.getTime() || date?.getTime() === 0;
        const isUnderConstraints =
            date?.getTime() <= new Date(this.min)?.setHours(0);
        const isRequired = this.rules.includes(ValidationRules.requiredRule);

        if (!isRealDate && isRequired) return "Неверная дата";
        if (isRealDate && isUnderConstraints) return "Слишком рано";
        else return true;
    }

    async mounted() {
        this.checkSuccess(this.fieldDate, this.rules);
    }
    @Prop({ default: true }) successable: boolean;
    success: boolean = false;
    checkSuccess(value, rules) {
        if (!rules) {
            this.success = true;
            return;
        }
        let state = false;
        for (let rule of rules) {
            if (typeof rule(value) === "string") {
                state = false;
                break;
            } else state = true;
        }
        this.success = state;
    }
}
